import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getPolicyType, getName } from "../js/formatting";
export const useCustomerClaimsMapper = () => {
  const {
    policies,
    claims: customerClaims,
    isLoading,
    error,
  } = useSelector((state) => state.data);
  const { user } = useSelector((state) => state.user);
  const [claims, setClaims] = useState([]);

  const getClaimSataus = (deathClaimStatus) => {
    switch (deathClaimStatus) {
      case "97":
      case "99":
        return "good";
      case "92":
        return "problem";
      default:
        return "risk";
    }
  };

  const getClaimstatusText = (deathClaimStatus) => {
    switch (deathClaimStatus) {
      case "01":
        return "Pending";
      case "97":
      case "99":
        return "Processed";
      case "93":
      case "98":
        return "Other";
      case "92":
        return "Denied";
    }
  };

  useEffect(() => {
    let claimList = [];
    if (customerClaims?.length > 0) {
      customerClaims.forEach((selectedClaim) => {
        let policy = policies.find(
          (x) => x.contractID === selectedClaim.contractID
        );
        let party = policy?.parties?.find(
          (x) => x.person?.type?.toLowerCase() === "primary owner"
        );
        claimList.push({
          oldPolicy: selectedClaim?.oldPolicy,
          id: selectedClaim?.contractID,
          title: `ID: ${
            selectedClaim?.claimType?.toLowerCase() === "dis"
              ? selectedClaim.claimNumber
              : selectedClaim.deathClaimNumber
          }`,
          deathClaimNumber: selectedClaim.deathClaimNumber,
          banner: getClaimSataus(selectedClaim?.deathClaimStatus), //policy?.paymentStatus?.toLowerCase() === 'approved' ? 'good' : policy?.paymentStatus?.toLowerCase() === 'declined' ? 'problem' : 'risk',
          badgeStatus: getClaimSataus(selectedClaim?.deathClaimStatus), // policy?.paymentStatus?.toLowerCase() === 'approved' ? 'good' : policy?.paymentStatus?.toLowerCase() === 'declined' ? 'problem' : 'risk',
          status: getClaimSataus(selectedClaim?.deathClaimStatus), // policy?.paymentStatus?.toLowerCase() === 'approved' ? 'good' : policy?.paymentStatus?.toLowerCase() === 'declined' ? 'problem' : 'risk',
          statusText: getClaimstatusText(selectedClaim?.deathClaimStatus), // selectedClaim?.claimStatusDescription,
          badgeSrText: getClaimstatusText(selectedClaim?.deathClaimStatus), //selectedClaim?.claimStatusDescription,
          badgeText: selectedClaim?.deathClaimStatus,
          policyNumber: policy?.contractID,
          contractID: selectedClaim?.contractID,
          owner:
            party?.person?.firstName && party?.person?.lastName
              ? `${policy ? `${getPolicyType(policy)} - ` : ""}${getName(
                  party?.person
                )}`
              : "",
          firstName: party?.person?.firstName,
          lastName: party?.person?.lastName,
          fullName: getName(party?.person),
          type: selectedClaim?.claimType,
          claimType: selectedClaim?.claimType,
          dateSubmitted: "",
          dateOfNotification: selectedClaim?.dateOfNotification,
          deathClaimStatus: selectedClaim?.deathClaimStatus,
          claimStatus:
            selectedClaim?.claimType?.toLowerCase() === "dis"
              ? selectedClaim.claimStatus
              : selectedClaim?.deathClaimStatus,
          step: 2,
          documents: [
            {
              badgeStatus: "good",
              badgeSrText: "Document",
              badgeText: "",
              name: "First Notice Of Loss",
              action: "View",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "good",
              badgeSrText: "Document",
              badgeText: "",
              name: "Claimant Form",
              action: "View",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "risk",
              badgeSrText: "Document",
              badgeText: "",
              name: "Claimant Form",
              action: "Update",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "good",
              badgeSrText: "Document",
              badgeText: "",
              name: "Another Required Form",
              action: "View",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
            {
              badgeStatus: "problem",
              badgeSrText: "Document",
              badgeText: "",
              name: "Another Required Form",
              action: "Update",
              path: "https://developer.adobe.com/document-services/static/AdobeInDesign-7e9e28ec01deaf8bb1c5f368c476162a.pdf",
            },
          ],
        });
      });
    }
    setClaims(claimList);
  }, [policies]);

  return {
    claims: claims,
  };
};
